import { hreflangMappper } from '@constants/hreflangMapper.consts'
import { getDomainExtension } from '@utils/getDomainExtension'
import React, { memo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

interface SeoHeadProps {
    title?: string
    description?: string
    noindex?: boolean
    locale?: keyof typeof hreflangMappper
    hreflangs?: {
        hreflang: string
        href: string
    }[]
}

const defaultLocale = 'de'

const SeoHead: React.FC<SeoHeadProps> = ({
    title,
    description,
    noindex = false,
    locale = getDomainExtension(),
    hreflangs
}) => {
    const location = useLocation()
    const path = location.pathname
    const currentDomain = hreflangMappper[locale]?.domain || defaultLocale
    const canonicalUrl = `${currentDomain}${path}`

    return (
        <Helmet>
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            <link rel="canonical" href={canonicalUrl} />

            {/* Hreflang tags */}
            {hreflangs?.map(({ hreflang, href }) => (
                <link key={hreflang} rel="alternate" hrefLang={hreflang} href={href} />
            ))}

            {hreflangs === undefined && (
                <>
                    {Object.entries(hreflangMappper).map(([key, { hreflang, domain }]) => (
                        <link key={hreflang} rel="alternate" hrefLang={hreflang} href={`${domain}${path}`} />
                    ))}
                </>
            )}
            <link rel="alternate" hrefLang="x-default" href={`${hreflangMappper[defaultLocale].domain}${path}`} />
        </Helmet>
    )
}

const MemoizedSeoHead = memo(SeoHead)
export { MemoizedSeoHead as SeoHead }
